// resources/js/Components/CookieConsent.jsx
import React, { useState, useEffect } from 'react';
import { usePage, Link } from '@inertiajs/react';

const CookieConsent = () => {
  const { lang } = usePage().props;
  const [isVisible, setIsVisible] = useState(false);

  const __ = (key) => lang?.messages?.[key] || key;

  useEffect(() => {
    // Revisamos si ya existe el consentimiento en el navegador
    const consent = localStorage.getItem('agasaja_cookie_consent');
    if (!consent) {
      // Pequeño delay para que no aparezca de golpe y se sienta más fluido
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleConsent = (decision) => {
    localStorage.setItem('agasaja_cookie_consent', decision);
    setIsVisible(false);
    
    if (decision === 'accepted') {
        // Aquí puedes disparar scripts de Google Analytics si los tienes
        console.log('Cookies aceptadas en Agasaja Academy');
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-[100] animate-in fade-in slide-in-from-bottom-10 duration-700">
      <div className="max-w-4xl mx-auto bg-gray-900 border border-gray-800 p-6 sm:p-8 rounded-[2.5rem] shadow-[0_20px_50px_rgba(0,0,0,0.3)] flex flex-col md:flex-row items-center justify-between gap-6">
        
        {/* Lado del Texto */}
        <div className="flex-1 text-center md:text-left">
          <div className="flex items-center justify-center md:justify-start gap-2 mb-2">
            <span className="text-amber-400 text-xl">🍪</span>
            <span className="text-white font-black uppercase tracking-tighter text-sm">Cookie Policy</span>
          </div>
          <p className="text-gray-400 text-sm leading-relaxed">
            {__('cookies_message') || 'Utilizamos cookies para mejorar tu experiencia de aprendizaje y analizar el tráfico.'}{' '}
            <Link href="/privacy" className="text-indigo-400 hover:text-indigo-300 underline font-bold">
                {__('read_more') || 'Leer más'}
            </Link>
          </p>
        </div>

        {/* Lado de los Botones */}
        <div className="flex items-center gap-3 w-full md:w-auto">
          <button
            onClick={() => handleConsent('declined')}
            className="flex-1 md:flex-none px-6 py-3 text-xs font-bold text-gray-500 hover:text-white transition-colors uppercase tracking-widest"
          >
            {__('cookies_decline') || 'Rechazar'}
          </button>
          <button
            onClick={() => handleConsent('accepted')}
            className="flex-1 md:flex-none px-8 py-4 text-xs font-black text-gray-900 bg-amber-400 rounded-2xl hover:bg-amber-300 transition-all shadow-lg shadow-amber-900/20 uppercase tracking-widest"
          >
            {__('cookies_accept') || 'Aceptar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;